import React, { useRef } from "react";
import routes from "../api/routes";
import buildApiRequestConfig from "../api/url-builder";
import useApi from "../hooks/use-api";

const Lab: React.FC = () => {
    const [classify, setClassify] = useApi();

    const handleClassify = async () => {
        const { url, method } = buildApiRequestConfig(routes.ai.classifyBusinessType);
        setClassify({
            url,
            method,
            body: {
                transactions: [
                    { description: "Starbucks Coffee",amount: 5.75 },
                    { description: "Whole Foods Market", amount: 45.20 },
                    { description: "Uber Ride", amount: 15.00 }
                ]
            }
        })
    };

    return (
        <div style={{ width: '100%' }}>
            <button onClick={handleClassify}>Classify Business Type</button>
            {classify && <pre>{JSON.stringify(classify, null, 2)}</pre>}
        </div>
    );
};

export default Lab;